import { render, staticRenderFns } from "./paper-comments.vue?vue&type=template&id=18a3441c&scoped=true"
import script from "./paper-comments.vue?vue&type=script&lang=js"
export * from "./paper-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3441c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a3441c')) {
      api.createRecord('18a3441c', component.options)
    } else {
      api.reload('18a3441c', component.options)
    }
    module.hot.accept("./paper-comments.vue?vue&type=template&id=18a3441c&scoped=true", function () {
      api.rerender('18a3441c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/se/view/paper-comments.vue"
export default component.exports